import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { RootState } from "@/models/states/RootState";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import campaignsModule from "./modules/campaigns";
import leadsModule from "./modules/leads";
import mainModule from "./modules/main";
import phonesModule from "./modules/phones";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "1",
  },

  getters,
  mutations,
  actions,

  modules: {
    campaignsModule,
    leadsModule,
    mainModule,
    phonesModule,
  },
  plugins: [createPersistedState({
    paths: [
      "campaignsModule.datePeriod",
      "campaignsModule.isMediaChannel",
      "campaignsModule.selectedCampaignStatus",
      "campaignsModule.selectedCampaignsIds",
      "campaignsModule.selectedChannelMetadataTypesIds",
      "campaignsModule.selectedClientsIds",
      "campaignsModule.selectedProjectsIds",
      "campaignsModule.showGraphs",

      "leadsModule.additionalStatuses",
      "leadsModule.adGroups",
      "leadsModule.adTitles",
      "leadsModule.assets",
      "leadsModule.assignees",
      "leadsModule.channels",
      "leadsModule.clients",
      "leadsModule.commitments",
      "leadsModule.datePeriod",
      "leadsModule.leadClientsDatePeriod",
      "leadsModule.leadClientsSearchValue",
      "leadsModule.leadClientsSelectedAdditionalStatusesIds",
      "leadsModule.leadClientsSelectedAdGroupsIds",
      "leadsModule.leadClientsSelectedAdTitles",
      "leadsModule.leadClientsSelectedAssetsIds",
      "leadsModule.leadClientsSelectedAssigneesIds",
      "leadsModule.leadClientsSelectedCallStatusesIds",
      "leadsModule.leadClientsSelectedChannelsIds",
      "leadsModule.leadClientsSelectedChannelMetadataTypesIds",
      "leadsModule.leadClientsSelectedClientsIds",
      "leadsModule.leadClientsSelectedCommitmentsIds",
      "leadsModule.leadClientsSelectedFoundMetadataTypesIds",
      "leadsModule.leadClientsSelectedLeadStatusesIds",
      "leadsModule.leadClientsSelectedPriceType",
      "leadsModule.leadClientsSelectedSaleStatusesIds",
      "leadsModule.leadClientsSelectedTags",
      "leadsModule.searchValue",
      "leadsModule.selectedAdditionalStatusesIds",
      "leadsModule.selectedAdGroupsIds",
      "leadsModule.selectedAdTitles",
      "leadsModule.selectedAssetsIds",
      "leadsModule.selectedAssigneesIds",
      "leadsModule.selectedCallStatusesIds",
      "leadsModule.selectedChannelsIds",
      "leadsModule.selectedChannelMetadataTypesIds",
      "leadsModule.selectedClientsIds",
      "leadsModule.selectedCommitmentsIds",
      "leadsModule.selectedFoundMetadataTypesIds",
      "leadsModule.selectedLeadStatusesIds",
      "leadsModule.selectedPriceType",
      "leadsModule.selectedSaleStatusesIds",
      "leadsModule.selectedTags",
      "leadsModule.showFavourite",
      "leadsModule.showGraphs",
      "leadsModule.showGraphsClientLeads",
      "leadsModule.tags",
      "leadsModule.uniqueByCampaign",
      "leadsModule.phonePopupData",

      "mainModule.userData",

      "phonesModule.datePeriod",
      "phonesModule.selectedCallStatus",
      "phonesModule.selectedChannelMetadataTypesIds",
      "phonesModule.selectedClientsIds",
      "phonesModule.selectedPhoneStatus",
      "phonesModule.selectedSourcesIds",
      "phonesModule.showGraphs",
    ],
  })]
};
export default new Vuex.Store<RootState>(store);
